import { CLOUD_LOGO } from "@/lib/brand";

export const AuthShell = ({ children }) => (
  <div className="min-h-screen grid lg:grid-cols-2">
    <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden" style={{ background: "#0B1F33" }}>
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full blur-3xl opacity-30" style={{ background: "#F7941E" }} />
      <div className="absolute bottom-0 -left-20 h-80 w-80 rounded-full blur-3xl opacity-20" style={{ background: "#0E4C7A" }} />
      <div className="relative">
        <img src={CLOUD_LOGO} alt="CloudPoweredIT" className="h-12 w-auto max-w-[230px] object-contain" />
      </div>
      <div className="relative">
        <h1 className="font-display text-white text-4xl xl:text-5xl font-bold leading-tight tracking-tight">
          Your projects,<br />in real time.
        </h1>
        <p className="text-slate-400 mt-5 max-w-md leading-relaxed">
          Track tickets, milestones, SEO performance and website analytics — all in one collaborative portal built by CloudPoweredIT.
        </p>
        <div className="flex gap-8 mt-10">
          {[["Live", "Ticketing"], ["SEO", "Analytics"], ["Real-time", "Collaboration"]].map(([a, b]) => (
            <div key={b}>
              <p className="text-orange-400 font-display font-bold text-lg">{a}</p>
              <p className="text-slate-500 text-xs uppercase tracking-wider">{b}</p>
            </div>
          ))}
        </div>
      </div>
      <p className="relative text-slate-600 text-xs">© 2026 CloudPoweredIT. All rights reserved.</p>
    </div>

    <div className="flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-sm">
        <div className="lg:hidden flex mb-8 justify-center">
          <img src={CLOUD_LOGO} alt="CloudPoweredIT" className="h-12 w-auto max-w-[210px] object-contain" />
        </div>
        {children}
      </div>
    </div>
  </div>
);
